export default __webpack_public_path__ + "images/car405c1dc6811d53f1a0554d696e8c18a4.svg";